<script setup lang="ts">
import { useCartStore } from "~/stores/cart";
import { useModalStore } from "~/stores/modal";

const { cartModal } = useModalStore();
const cartStore = useCartStore();
const windowSize = useWindowSize();
const windowScroll = useWindowScroll();

const isBorderShown = computed(() => windowSize.width.value < 1025 && windowScroll.y.value > 0);
</script>

<template>
	<header
		:class="isBorderShown && 'border-b border-b-gray'"
		class="py-4 px-8 flex items-center justify-between bg-white top-0 z-30 sm:sticky sm:px-6 xs:sticky xs:px-4"
	>
		<LayoutHeaderMenu class="block md:hidden lg:hidden" />
		<div class="flex items-center">
			<LayoutLogo class="mx-4" />
			<LayoutHeaderNav class="sm:hidden xs:hidden" />
		</div>
		<div class="flex items-center gap-x-5">
			<HomeSearch class="w-[320px] sm:hidden xs:hidden" />
			<div class="flex items-center gap-x-3">
				<!-- <AppButtonIcon
					class="hover:text-pink"
					name="solar:heart-outline"
				/> -->
				<LayoutHeaderNavButtonCart
					:items-in-cart="cartStore.cart.length"
					@click="cartModal.openModal"
				/>
			</div>
		</div>
	</header>
</template>
